<template><div /></template>
<script>
export default {
  name:"GoogleMarker",
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    marker: {
      type: Object,
      required: true
    }
  },
  methods: {
    markerMoved() {
      this.$emit("marker-moved", this.localMarker);
    },
    updateMarker() {
      var _vue = this;
      this.localMarker = new this.google.maps.Marker({
        position: this.marker.position,
        icon: "https://maps.google.com/mapfiles/kml/paddle/purple-stars.png",
        marker: this.marker,
        draggable: true,
        map: this.map
      });
      this.map.panTo(
        new this.google.maps.LatLng(
          this.marker.position.lat,
          this.marker.position.lng
        )
      );

      this.google.maps.event.addListener(this.localMarker, "dragend", function(
        event
      ) {
        console.log(event);
        _vue.markerMoved();
      });
    }
  },
  data() {
    return {
      localMarker: null
    };
  },
  watch: {
    marker: function(newMarker, oldMarker) {
      console.log(newMarker, oldMarker);
      if (this.localMarker !== null) this.localMarker.setMap(null);
      this.updateMarker();
    }
  },
  mounted() {
    this.updateMarker();
  }
};
</script>
